import { useMutation, useQueryClient } from '@tanstack/react-query';
import $api from 'api';
import { useAuth } from 'context/AuthContext';
import type { IUser } from 'types';

function useReadChat() {
  const queryClient = useQueryClient();
  const { profile } = useAuth();

  return useMutation({
    mutationFn: ({ chatId }: { chatId: number }) => {
      return $api.patch(`/chats/${chatId}/read`);
    },
    onSuccess: ({ data }) => {
      const participantId = data.participants.find(
        (participant: IUser) => participant.id !== profile?.id,
      )?.id;
      queryClient.setQueryData(['chat', participantId], () => {
        return data;
      });
      queryClient.invalidateQueries({ queryKey: ['chats'] });
    },
  });
}

export default useReadChat;
